import ApiModel from './ApiModel';
import { ServerError } from './ApiModel';

export default abstract class USServiceModel extends ApiModel {
    protected abstract get serviceId(): string;

    handleErrorRequest(error: any): Error {
        if (error.message === 'Network Error') {
            return new ServerError(error.message, -1, this.serviceId);
        } else if ((error.message as string).substr(0, 7) === 'timeout') {
            return new ServerError(error.message, -2, this.serviceId);
        }
        return new ServerError(error.message, -3, this.serviceId);
    }

    handleErrorResponse(response: any): ServerError {
        if (response.data && response.data.data) {
            var data = response.data.data;
            var e: ServerError = new ServerError(data.reason, data.code, this.serviceId);
        } else {
            e = new ServerError("server error", 101, this.serviceId);
        }
        return e;
    }
}